<template>
  <div>
    <div class="logo-main" v-if="showLogo">
        <van-image fit="fill" class="logo-img" :src="cdnUrl + logo" />
    </div>
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0C68A9" @change="onChange">
      <van-swipe-item v-for="(item,index) in img_url" :key="index" @click="handleImage(item.redirect_url)">
        <van-image fit="fill" class="slider-img" :src="cdnUrl + item.img_url" />
      </van-swipe-item>
      <template #indicator>
        <div class="custom-indicator">
          <span v-for="(item,index) in img_url" :key="index" class="custom-item" :class="index== current ? 'cus-item-active' : ''"></span>
        </div>
      </template>
    </van-swipe>
  </div>
</template>

<script>
import { getBannerList } from '@/api/label'
export default {
    props: {
        type: {
            type: Number,
        },
        showLogo: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            current: 0,
            logo: 'Fr23uoHKjiB7Qkl23ZZ7MyJ1imlp',
            img_url: []
        }
    },
    created() {
        this.getList()
    },
    methods: {
        getList() {
            getBannerList({ type: this.type }).then(res => {
                this.img_url = res.data.data
            })
        },
        onChange(index) {
            this.current = index;
        },
        handleImage(url) {
            if (!url) return;
            window.location.href = url
        }
    }
}
</script>

<style lang="scss" scoped>
.my-swipe {
  width: rem(693/2);
  height: rem(385/2);
  margin: 0 auto;
  border-radius: 13px;
  .slider-img {
      width: 100%;
      height: 100%;
  }
}
.logo-main {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: rem(42);
    .logo-img {
        float: right;
        margin-right: 15px;
        width: rem(118);
        height: rem(35);
    }
}

.custom-indicator {
    position: absolute;
    right: 5px;
    bottom: 5px;
    .custom-item {
        display: inline-block;
        width: rem(7);
        height: rem(7);
        margin-right: 3px;
        background: #abd8e3;
        border-radius: 50%;
    }
    .cus-item-active {
        width: rem(19);
        background: #67c3d9;
        border-radius: 5px;
    }
}
</style>